
function downloadAsFile(response, fileName) {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}

function downloadAsFileByURL(targetFileURL, fileName = '') {
  const link = document.createElement('a');
  link.href = targetFileURL;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}

export {
  downloadAsFile,
  downloadAsFileByURL,
}
